import { Currency } from '@seapoint/server/enums';
import { Stack } from '../../../design-system/stack/stack';
import { cn } from '../../../utils/cn';
import { getAmountWithCurrency } from '../../../utils/get-amount-with-currency';

type AccountsSummaryProps = {
  currency: Currency;
  accountBalance: number;
  isSelected?: boolean;
  onResetSelectedAccount?: () => void;
};

export const AllAccountsSummaryCard = ({
  currency,
  accountBalance,
  isSelected,
  onResetSelectedAccount,
}: AccountsSummaryProps) => {
  const balanceAmount = getAmountWithCurrency({ amount: accountBalance, currency, isAccountBalance: true });

  return (
    <Stack
      space={2}
      className={cn(
        'h-[84px] w-52 cursor-pointer rounded-lg border-2 bg-white px-5 py-4 transition-all duration-200 hover:bg-accent',
        isSelected ? 'border-primary bg-white' : 'border-transparent bg-muted',
      )}
      onClick={onResetSelectedAccount}
    >
      <p className="text-xs leading-4 font-medium text-black">Account balance</p>
      <p className="text-xl leading-7 font-medium text-black">{balanceAmount}</p>
    </Stack>
  );
};
